import React, { useContext, useReducer, useState, useEffect } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import { MenuList } from "./Menu";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = { active: "", activeSubmenu: "" };

const SideBar = () => {
  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);
  const [hideOnScroll, setHideOnScroll] = useState(true);

  // Check if any menu is active in localStorage on initial load
  useEffect(() => {
    const activeMenu = localStorage.getItem("activeMenu");
    const activeSubmenu = localStorage.getItem("activeSubmenu");

    if (activeMenu) {
      setState({ active: activeMenu });
    }

    if (activeSubmenu) {
      setState({ activeSubmenu: activeSubmenu });
    }
  }, []);

  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  const handleMenuActive = (menuTitle) => {
    if (state.active === menuTitle) {
      // Collapse the menu and reset the submenu
      setState({ active: "", activeSubmenu: "" });
      localStorage.removeItem("activeMenu");
      localStorage.removeItem("activeSubmenu");
    } else {
      // Open the new menu and reset the submenu
      setState({ active: menuTitle, activeSubmenu: "" });
      localStorage.setItem("activeMenu", menuTitle);
      localStorage.removeItem("activeSubmenu");
    }
  };

  const handleSubmenuActive = (submenuTitle) => {
    if (state.activeSubmenu === submenuTitle) {
      // Collapse the submenu
      setState({ activeSubmenu: "" });
      localStorage.removeItem("activeSubmenu");
    } else {
      // Open the new submenu
      setState({ activeSubmenu: submenuTitle });
      localStorage.setItem("activeSubmenu", submenuTitle);
    }
  };

  /// Path
  let path = window.location.pathname;
  path = path.replace(/\/$/, ""); // Remove trailing slash if present

  const isActiveMenu = (menuPath) => {
    return path === menuPath || path.startsWith(menuPath);
  };

  return (
    <div className="deznav">
      <PerfectScrollbar className="deznav-scroll">
        <ul className="metismenu" id="menu">
          {MenuList.map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === "menu-title") {
              return (
                <li className={menuClass} key={index}>
                  {data.title}
                </li>
              );
            } else {
              return (
                <li
                  className={`${
                    isActiveMenu(data.to) || state.active === data.title
                      ? "mm-active"
                      : ""
                  }`}
                  key={index}
                >
                  {data.content && data.content.length > 0 ? (
                    <>
                      <Link
                        to={"#"}
                        className="has-arrow"
                        onClick={() => handleMenuActive(data.title)} // Handles submenu reset
                      >
                        {data.iconStyle}
                        <span className="nav-text">{data.title}</span>
                      </Link>
                      <Collapse in={state.active === data.title}>
                        <ul
                          className={`${
                            menuClass === "mm-collapse" ? "mm-show" : ""
                          }`}
                        >
                          {data.content.map((submenu, idx) => (
                            <li
                              key={idx}
                              className={`${
                                isActiveMenu(submenu.to) ||
                                state.activeSubmenu === submenu.title
                                  ? "mm-active"
                                  : ""
                              }`}
                            >
                              {submenu.content && submenu.content.length > 0 ? (
                                <>
                                  <Link
                                    to={submenu.to}
                                    className={submenu.hasMenu ? "has-arrow" : ""}
                                    onClick={() =>
                                      handleSubmenuActive(submenu.title)
                                    }
                                  >
                                    {submenu.title}
                                  </Link>
                                  <Collapse
                                    in={
                                      state.activeSubmenu === submenu.title
                                        ? true
                                        : false
                                    }
                                  >
                                    <ul
                                      className={`${
                                        menuClass === "mm-collapse"
                                          ? "mm-show"
                                          : ""
                                      }`}
                                    >
                                      {submenu.content.map(
                                        (subSubmenu, subIdx) => (
                                          <li key={subIdx}>
                                            <Link
                                              className={`${
                                                isActiveMenu(subSubmenu.to)
                                                  ? "mm-active"
                                                  : ""
                                              }`}
                                              to={subSubmenu.to}
                                            >
                                              {subSubmenu.title}
                                            </Link>
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  </Collapse>
                                </>
                              ) : (
                                <Link
                                  className={`${
                                    isActiveMenu(submenu.to) ? "mm-active" : ""
                                  }`}
                                  to={submenu.to}
                                >
                                  {submenu.title}
                                </Link>
                              )}
                            </li>
                          ))}
                        </ul>
                      </Collapse>
                    </>
                  ) : (
                    <Link
                      to={data.to}
                      className={`${
                        isActiveMenu(data.to) ? "mm-active" : ""
                      }`}
                      onClick={() => handleMenuActive(data.title)} // Resets submenu
                    >
                      {data.iconStyle}
                      <span className="nav-text">{data.title}</span>
                    </Link>
                  )}
                </li>
              );
            }
          })}
        </ul>
      
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
